import * as React from 'react';
import { IOdd } from 'eTip--common';
import { EventRate } from 'common--design-library';
import classNames from 'classnames';


interface IGameDetail {
    odds: IOdd[];
}

type IActiveTips = {
    [key: string]: string;
};

export interface ILiveEventOddsProps {
    gameDetail: IGameDetail;
    setTipOnCoupon: (odd: IOdd) => void;
    activeTips: IActiveTips;
    inactiveTips: IActiveTips;
}


export const EventOdds = (props: ILiveEventOddsProps) => {
    const { odds } = props.gameDetail;

    function getTestRole(index: number, numberOfOdds: number): string | null {
        if (numberOfOdds == 3) {
            switch (index) {
                case 0: return "live-event-home";
                case 1: return "live-event-draw";
                case 2: return "live-event-away";
            }
        } else if (numberOfOdds == 2) {
            switch (index) {
                case 0: return "live-event-home";
                case 1: return "live-event-away";
            }
        }
        return null;
    }

    const numberOfOdds = odds.length;

    return <div className="d-flex justify-content-between">
        <div className="text-center flex-grow-1 w-100">
            <div className="d-flex">
                {odds.map((odd, index) => <React.Fragment key={index}>
                    <EventRate
                        active={props.activeTips && !!props.activeTips[odd.key]}
                        inactive={props.inactiveTips && !!props.inactiveTips[odd.key]}
                        oddKey={odd.key}
                        ident={odd.ident}
                        name={odd.name}
                        rate={odd.rate}
                        onClick={() => { props.setTipOnCoupon(odd); }}
                        isSuspended={odd.isSuspended}
                        className={classNames("flex-grow-1", __IsMTSTipos__ ? null : " mr-1")}
                        showTipsInside={true}
                        roleForTest={getTestRole(index, numberOfOdds)}
                        tooltipIdPrefix="liveEventListOdds"
                    />
                </React.Fragment>
                )}
            </div>
        </div>
    </div >
}
